export default __webpack_public_path__ + "static/media/background-paralax-1.df4382bb.png";